/**
 * /app/$tenantSlug/payroll/tax-declaration — old home of "My tax
 * declaration". Navigation rebuild (wave 3, 28 Oct 2026): the page is now
 * Me → Pay → Tax (/me/tax); this route only redirects so notification
 * links stored in the database ("/payroll/tax-declaration", sent when HR
 * verifies an item or finalises a declaration) and bookmarks keep working.
 *
 * The HR pages under this prefix are unchanged: the queue at
 * /payroll/tax-declaration/queue and a review at /payroll/tax-declaration/{id}.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { MY_TAX_PATH } from "@/lib/me-redirects";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/payroll/tax-declaration/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: MY_TAX_PATH,
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
